<template>
  <div class="flex h-full rounded-md border border-gray-200">
    <button
      v-for="(option, index) in options"
      :key="option.value"
      class="h-full flex-1 px-3 py-3 text-xs transition-colors"
      :class="{
        'bg-blue-100 text-blue-700': modelValue === option.value,
        'bg-transparent text-gray-700 hover:bg-gray-50':
          modelValue !== option.value,
        'border-r border-gray-200': index < options.length - 1,
      }"
      :data-cy="dataCyPrefix ? `${dataCyPrefix}-${option.value}` : undefined"
      @click="$emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script setup lang="ts">
export interface ButtonGroupOption {
  value: string | number;
  label: string;
}

defineProps<{
  options: ButtonGroupOption[];
  modelValue: string | number;
  dataCyPrefix?: string;
}>();

defineEmits<{
  "update:modelValue": [value: string | number];
}>();
</script>
